import axios, { Method } from "axios";
import { isMoment } from "moment";
import * as admin from "./admin";
import qs from "qs";

export const Admin = admin;

// export const baseURL = "http://3.35.80.215:61251/api/v1/";


// export const baseURL = "http://192.168.0.26:62100/api/v1/";
export const baseURL = "https://api.channel-dna.com/api/v1/";
//  export const baseURL = "https://healandapi.cubemedical.co.kr:62100/api/v1/";


// process.env.NODE_ENV === "development"
//   ? "http://192.168.10.62:61251/api/v1/"
//   : `http://${location.hostname}/api/v1/`;
// export const baseURL = "http://localhost:61251/api/v1/";
// export const baseURL = "http://3.35.80.215:61251/api/v1/";


export const _axios = axios.create({
  baseURL: baseURL,
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
  paramsSerializer: (params: any) =>
    qs.stringify(params, {
      allowDots: true,
      encodeValuesOnly: true,
      arrayFormat: "indices",
    }),
});

export default class Api {
  static shopIndex = null;

  static async getAuthorizeHeader() {
    const token = localStorage.getItem("token");

    return token || Api.shopIndex
      ? {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          ...(Api.shopIndex ? { ShopIndex: `${Api.shopIndex}` } : {}),
        }
      : {};
  }

  static async send(options: {
    url: string;
    method: Method;
    params?: any;
    data?: any;
    isForm?: boolean;
  }) {
    try {
      const { url, method, params, data, isForm = false } = options;

      const res = await _axios.request({
        url,
        method,
        params,
        data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          ...(isForm
            ? {}
            : {
                ...(await Api.getAuthorizeHeader()),
              }),
        },
      });

      return res.data;
    } catch (ex) {
      console.error(ex);
      throw ex;
    }
  }

  static async get(url?: string, params?: any) {
    return await Api.send({ method: "GET", url: url ?? "", params });
  }

  static async del(url?: string, params?: any) {
    return await Api.send({ method: "DELETE", url: url ?? "", params });
  }

  static async post(url?: string, data?: any, params?: any) {
    return await Api.send({ method: "POST", url: url ?? "", data, params });
  }

  static async put(url?: string, data?: any, params?: any) {
    return await Api.send({ method: "PUT", url: url ?? "", data, params });
  }

  static async form(url?: string, file?: File, method?: Method) {
    return await Api.send({
      method: method || "PUT",
      url: url ?? "",
      data: file,
      isForm: true,
    });
  }
}
